import { IonPage } from '@ionic/react';
import styled from 'styled-components';

export const TemplateAdminPage = styled(IonPage)`
  .align-end {
    display: flex;
    justify-content: end;
  }
`;
